/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockClosedIcon24Solid = forwardRef('SecurityLockClosedIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 .9A6.1 6.1 0 0 0 5.9 7v1.153A4.002 4.002 0 0 0 3 12v6a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-6a4.002 4.002 0 0 0-2.9-3.847V7A6.1 6.1 0 0 0 12 .9ZM15.9 8V7a3.9 3.9 0 0 0-7.8 0v1h7.8Zm-3.025 7.799a2 2 0 1 0-1.75 0v1.7a.875.875 0 1 0 1.75 0v-1.7Z" })));
});
